
import woking from './images/woking.png'
import cardinal from './images/Cardinal1.png'
import richmond from './images/richmond.png'
import tunbridge from './images/tunbridge.png'
import wilberforce from './images/wilberforce.png'
import kingston from './images/Kingston.png'
import holland from './images/holland.png'
import nursery from './images/nursery.png'
import hillingdon from './images/hillingdon.png'
import glasgow from './images/Glasgow.png'
import guildford from './images/Guildford.png'
import northampton from './images/Northampton.png'
import amersham from './images/amersham.png'
import merton from './images/Merton.png'
import stratford from './images/Stratford.png'

import wokingPicture from './images/Woking_overview_section.jpeg'
import cardinalPicture from './images/Cardinal_overview_section.jpg'
import richmondPicture from './images/Richmond_overview_section.jpeg'
import tunbridgePicture from './images/Tunbridge Well_overview_section.jpeg'
import wilberforcePicture from './images/Wilberforce_overview_section.jpg'
import kingstonPicture from './images/Kingston_overview_section.jpg'
import hollandPicture from './images/Holland_overview_section.jpg'
import nurseryPicture from './images/Tadpoles_overview_section.png'
import hillingdonPicture from './images/Hillingdon_overview_section.png'
import glasgowPicture from './images/Glasgow_overview_section.jpeg'
import guildfordPicture from './images/Guilford_overview_section.jpg'
import northamptonPicture from './images/Northampton_overview_section.jpg'
import amershamPicture from './images/Amersham_overview_section.JPG'
import mertonPicture from './images/Merton_overview_section.jpeg'
import stratfordPicture from './images/stratfordOverview.png'
import academyLogo from './images/OnlineAcademyLogo.png'


export const SCHOOLS_LIST = [
    {
        name: 'academy',
        image: academyLogo,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/92dcbe7c15c62e08/',
        schoolPhoto: academyLogo,
        isAcademy: true
    },
    {
        name: 'woking',
        image: woking,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/8311c3a7eb3b7315/',
        schoolPhoto: wokingPicture

    },
    {
        name: 'cardinal',
        image: cardinal,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/5253a6c2c52c43c7/',
        schoolPhoto: cardinalPicture
    },
    {
        name: 'richmond',
        image: richmond,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/1d049b21b3ecf895/',
        schoolPhoto: richmondPicture
    },
    {
        name: 'tunbridge',
        image: tunbridge,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/fd5c3083dcbc280f/',
        schoolPhoto: tunbridgePicture
    },
    {
        name: 'wilberforce',
        image: wilberforce,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/1735a04cff4f65f8/',
        schoolPhoto: wilberforcePicture
    },
    {
        name: 'kingston',
        image: kingston,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/1550bcac5a4d00fc/',
        schoolPhoto: kingstonPicture
    },
    {
        name: 'holland',
        image: holland,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/85885b7fe375d7cd/',
        schoolPhoto: hollandPicture
    },
    {
        name: 'nursery',
        image: nursery,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/95b1c6a3dc0888f4/',
        schoolPhoto: nurseryPicture
    },
    {
        name: 'hillingdon',
        image: hillingdon,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/d42175d9835bc89c/',
        schoolPhoto: hillingdonPicture
    },
    {
        name: 'glasgow',
        image: glasgow,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/69ebaf908555de25/',
        schoolPhoto: glasgowPicture
    },
    {
        name: 'guildford',
        image: guildford,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/be53e09fc93db6fb/',
        schoolPhoto: guildfordPicture
    },
    {
        name: 'northampton',
        image: northampton,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/e33258a8370aa228/',
        schoolPhoto: northamptonPicture
    },
    {
        name: 'amersham',
        image: amersham,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/141904c527a628be/',
        schoolPhoto: amershamPicture
    },
    {
        name: 'merton',
        image: merton,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/e888c18183e22da7/',
        schoolPhoto: mertonPicture
    },
    {
        name: 'stratford',
        image: stratford,
        registerLink: 'https://app.upshot.org.uk/signup/4a120cd8/bd86be2c226540c3/',
        schoolPhoto: stratfordPicture  // Placeholder for future image


    }
    /*{
        name: 'stratford'
        //image: stratford
    }*/
];
